export default {
    excess: 'Udział własny',
    security: 'Depozyt zabezpieczający',
    fuel_policy: 'Polityka paliwowa',
    like_for_like: 'Podobny za podobny',
    full_to_full: 'Pełny do pełnego',
    mileage: 'Limit kilometrów: {mileage} km na wynajem',
    unlimited_mileage: 'Nielimitowany przebieg',
    non_refundable: 'Bezzwrotne',
    free_cancellation_until: 'Bezpłatne anulowanie do {date}',
    cancellation_with_terms: 'Anulowanie {0} zgodnie z ',
    t_c_text: 'Regulaminem',
    two_free_extras: 'Dwa darmowe dodatki przy odbiorze',
    glass_tyres_covered: 'Szyby i opony objęte ochroną',
    spec_fuel_petrol: 'benzyna',
    spec_fuel_petrol_diesel: 'benzyna/diesel',
};
